import React from 'react'
import AuditAdminMenu from '../AuditAdminMenu'
import {AuditContext} from '../../context/Audits'
import {AuditPaneContext} from '../../context/AuditPane'
import {UserContext} from '../../context/User'
import {useTranslation} from 'react-i18next'
import lowerCase from 'lodash/lowerCase'
import upperCase from 'lodash/upperCase'
import {Dropdown, Form, InputGroup} from 'react-bootstrap'
import Spinner from 'react-bootstrap/Spinner'
import search_icon from '../../assets/images/search.png'
import moment from 'moment'
import {Table, Column, InfiniteLoader} from 'react-virtualized'

const filterIntervals = ['0', '30', '90', '180']
const statusValues = {
  completed: 'green',
  incomplete: 'green',
  open: 'blue',
}

function AuditTab({tabWidth}) {
  const {
    audits,
    audit,
    getAll,
    getNextAudits,
    selectAudit,
    setSearchParams,
    searchParams,
    getItemsCount,
    date_format,
  } = React.useContext(AuditContext)

  const [start, setStart] = React.useState(1)
  const [loading, setLoading] = React.useState(true)
  const user = React.useContext(UserContext)
  const {isExpandOpen, openSidebar, isSidebarOpen, isDefault, openModal} = React.useContext(
    AuditPaneContext
  )
  const searchInput = React.createRef()
  const {t} = useTranslation()
  const permission = (user?.details && user.details.canCreate) || false
  const width = tabWidth

  React.useEffect(() => {
    if (user.details && user.details.id) {
      setStart(1)
      getAll({start: 1, ...searchParams})
      if (audits.audits && audits.audits.length) {
        let auditsArray = audits.audits.map(i => {
          return i.id
        })
        //getItemsCount(auditsArray)
      }
    }
    //eslint-disable-next-line
  }, [getAll, searchParams, user])

  React.useEffect(() => {
    if (audits.audits && !audits.isCountLoaded && !audits.isLoading) {
      //if(audits.audits && audits.audits.length && !audits.isLoading && !audits.isCountLoaded){
      let auditsArray = audits.audits.map(i => {
        return i.id
      })
      getItemsCount(auditsArray)
    }

    //eslint-disable-next-line
  }, [audits.isCountLoaded, getItemsCount])

  const setSearchParamsChange = evtkey => {
    setSearchParams({...searchParams, due_filter: evtkey})
  }

  const handleRecordSelect = (index, data) => {
    if (audit === null || (audit && audit.selected && audit.selected.id) !== data.id) {
      selectAudit(data)
    }
    !isExpandOpen && openSidebar('audit')
  }

  const handleSearch = event => {
    setSearchParams({...searchParams, query: event.target.value.trim()})
  }

  const handleSearchWithClick = () => {
    const query = (searchInput && searchInput.current && searchInput.current.value.trim()) || ''
    setSearchParams({...searchParams, query})
  }

  const pillbox = due_status => {
    const due = lowerCase(due_status).replace(' ', '_')
    const pillVariants = {
      due_soon: 'yellow',
      new: 'blue',
      incomplete: 'red',
      past_due: 'red',
    }
    return (
      due &&
      !isExpandOpen && (
        <span
          className={
            `ap-pillbox ml_5` +
            `${pillVariants[due_status] ? ` ap-pillbox--${pillVariants[due_status]}` : ''}` +
            `${isSidebarOpen ? ' ap-pillbox--shrink' : ''}`
          }
        >
          {isDefault && t(`audit.tab.pill.${due}`)}
        </span>
      )
    )
  }

  const bubble = content => <span className="ap-bubble ml_5">{content}</span>

  const loadMore = () => {
    if (loading) {
      setLoading(false)
      getNextAudits({start: start + 1, ...searchParams}).then(() => {
        setStart(start + 1)
        setLoading(true)
      })
    }
  }

  const columnName = data => {
    if (data.rowData.name === '') {
      return <Spinner className="audit-spinner mt-15" animation="border" role="status" />
    }
    return (
      <div
        title={data.rowData.name}
        className="audit-table__cell audit-table__cell--pad-left audit-table__cell--expand"
        onClick={() => handleRecordSelect(data.rowIndex, data.rowData)}
      >
        <div className="overflow-content">{data.rowData.name}</div>
        {pillbox(data.rowData.due_status)}
      </div>
    )
  }

  const columnStatus = data => {
    return (
      <div
        className={`${statusValues[data.rowData.status] &&
          ` audit-table__cell--${statusValues[data.rowData.status]}`}`}
        onClick={() => handleRecordSelect(data.rowIndex, data.rowData)}
      >
        {(statusValues[data.rowData.status] && t(`audit.table.status.${data.rowData.status}`)) ||
          t(`audit.table.status.scheduled`)}
      </div>
    )
  }

  const columnAssignee = data => {
    return (
      <div onClick={() => handleRecordSelect(data.rowIndex, data.rowData)}>
        {data.rowData.audit_users_attributes && data.rowData.audit_users_attributes.length > 1 ? (
          <>
            {`${data.rowData.audit_users_attributes[0].user_name}, `}
            {bubble(`+${data.rowData.audit_users_attributes.length - 1}`)}
          </>
        ) : data.rowData.audit_users_attributes &&
          data.rowData.audit_users_attributes.length !== 0 ? (
          data.rowData.audit_users_attributes[0].user_name
        ) : (
          ''
        )}
      </div>
    )
  }

  const columnScanned = data => {
    return (
      <div
        className={`${data.rowData.status === 'incomplete' ? 'audit-table__cell--red' : ''}`}
        onClick={() => handleRecordSelect(data.rowIndex, data.rowData)}
      >
        {data.rowData.status === 'incomplete'
          ? `${data.rowData.scanned_items_count} / ${data.rowData.total_items_count} !`
          : `${data.rowData.scanned_items_count} / ${data.rowData.total_items_count}`}
      </div>
    )
  }

  const columnDueDate = data => {
    return (
      <div onClick={() => handleRecordSelect(data.rowIndex, data.rowData)}>
        {data.rowData.due_date &&
          data.rowData.due_date !== '12/31/2100' &&
          moment(data.rowData.due_date).format(date_format)}
      </div>
    )
  }

  const columnData = (data, value) => {
    return <div onClick={() => handleRecordSelect(data.rowIndex, data.rowData)}>{value}</div>
  }

  const _sort = e => {
    let column_name = e.sortBy
    let sort_by = e.sortDirection
    setSearchParams({...searchParams, sort_by, column_name})
  }

  const sortHeader = (data, className = '') => {
    return (
      <div
        className={`audit-table__header audit-icon--sort p-0 ${
          searchParams.column_name === data.dataKey
            ? data.sortDirection === 'ASC'
              ? ' audit-icon--sort-asc'
              : ' audit-icon--sort-desc'
            : ''
        }`}
      >
        <span className={className} title={data.label}>
          {data.label}
        </span>
      </div>
    )
  }

  const _noRowsRenderer = () => {
    if (
      audits &&
      !audits.isLoading &&
      audits.total_audits === 0 &&
      searchParams.query === '' &&
      searchParams.due_filter === '0'
    ) {
      return (
        <div className="text_center audit-table__cell--none audit-table__cell--gray audit-table__cell--expand">
          <span className="font_20">
            {t('audit.tab.none.created')}
            <br />
            {permission && t('audit.tab.none.suggestion')}
          </span>
          <br />
          {permission && (
            <button className="audit-button audit-button--blue mt_20" onClick={() => openModal()}>
              {t('audit.button.create')}
            </button>
          )}
        </div>
      )
    } else if (audits && audits.isLoading) {
      return (
        <div className="text_center">
          <Spinner className="audit-spinner mt-15" animation="border" role="status" />
        </div>
      )
    } else {
      return (
        <div className="text_center audit-table__cell--none audit-table__cell--gray audit-table__cell--expand">
          <span className="font_20"> {t('audit.tab.none.found')}</span>
        </div>
      )
    }
  }

  const _rowClassName = index => {
    if (
      index !== -1 &&
      audits.audits &&
      audit.selected &&
      audits.audits[index].id === audit.selected.id &&
      (isExpandOpen || isSidebarOpen)
    ) {
      return 'audit-table__row audit-table__row--no-border-top cursor_pointer audit-table__row--highlighted'
    } else if (index !== -1 && audits.audits[index].id === 'loading') {
      return 'audit-table__row audit-table__row--no-border-top cursor_pointer loading_row'
    } else {
      return 'audit-table__row audit-table__row--no-border-top cursor_pointer'
    }
  }

  const columnAction = data => {
    if (
      data.rowData.audit_type_for_user === 'created' ||
      data.rowData.audit_type_for_user === 'assigned' ||
      user.details.is_admin
    ) {
      return <AuditAdminMenu close data={data.rowData} />
    } else {
      return <span className="actionSize"></span>
    }
  }

  return (
    <>
      {!permission ? <h5 className="audit-tab__header">{t('audit.tab.header')}</h5> : ''}
      <Dropdown
        onSelect={e => setSearchParamsChange(e)}
        className={'audit-dropdown audit-dropdown--filter mt-18'}
      >
        <Dropdown.Toggle className={`audit-dropdown__toggle ${permission ? 'm_24_10' : 'm_13_0'}`}>
          {t(`audit.tab.filter.${searchParams.due_filter}`)}
        </Dropdown.Toggle>
        <Dropdown.Menu className="audit-dropdown__menu">
          {filterIntervals.map(filter => (
            <Dropdown.Item
              active={searchParams.due_filter === filter}
              className="audit-dropdown__item font_14"
              eventKey={filter}
              key={filter}
            >
              {t(`audit.tab.filter.${filter}`)}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      {!isExpandOpen && (
        <span className={permission ? 'audit-search' : ' mt_0 audit-search-no-permission'}>
          <InputGroup className="audit__input-group">
            <Form.Control
              className="audit__input audit__input--search"
              placeholder={t('audit.tab.search')}
              onKeyPress={event => {
                if (event.key === 'Enter') {
                  handleSearch(event)
                }
              }}
              ref={searchInput}
              defaultValue={searchParams.query}
            />
            <InputGroup.Append>
              <img
                src={search_icon}
                className={permission ? 'audit-search__image' : 'audit-search__image-no-permission'}
                alt="img"
                onClick={handleSearchWithClick}
              ></img>
            </InputGroup.Append>
          </InputGroup>
        </span>
      )}
      <div
        className={
          !isExpandOpen
            ? 'audit-tab__table position-unset'
            : 'audit-tab__table position-unset expand_page'
        }
      >
        {audits && audits.audits && (
          <>
            <div className="main-container">
              <h1 className="tableTitleText">
                Infinite scrolling autosize table for template table with sorting in each column,
                filter, search and action dropdown for both admin and user
              </h1>
              <InfiniteLoader
                isRowLoaded={({index}) => !!audits.audits[index]}
                loadMoreRows={loadMore}
                rowCount={audits.total_audits}
                threshold={5}
              >
                {({onRowsRendered, registerChild}) => (
                  <Table
                    ref={registerChild}
                    onRowsRendered={onRowsRendered}
                    className="audit-table"
                    headerHeight={33}
                    rowClassName={h => _rowClassName(h.index)}
                    width={width}
                    height={735}
                    rowHeight={40}
                    rowCount={audits.audits.length}
                    rowGetter={({index}) => audits.audits[index]}
                    rowStyle={{overflow: 'visible'}}
                    sort={e => _sort(e)}
                    sortBy={searchParams.column_name}
                    sortDirection={searchParams.sort_by}
                    noRowsRenderer={_noRowsRenderer}
                  >
                    <Column
                      headerRenderer={h =>
                        sortHeader(h, 'ReactVirtualized__Table__headerTruncatedText')
                      }
                      cellRenderer={columnName}
                      className="audit-name__cell"
                      label={upperCase(t('audit.table.columns.name'))}
                      dataKey="name"
                      width={width * 0.3}
                      flexGrow={1}
                    />
                    {!isExpandOpen && (
                      <Column
                        headerRenderer={h => sortHeader(h)}
                        cellRenderer={columnStatus}
                        className="audit-table__cell"
                        label={upperCase(t('audit.table.columns.status'))}
                        dataKey="status"
                        width={width * 0.1}
                        flexGrow={1}
                      />
                    )}
                    {!isExpandOpen && permission && (
                      <Column
                        disableSort={true}
                        cellRenderer={columnAssignee}
                        className="audit-table__cell"
                        label={upperCase(t('audit.table.columns.assignee'))}
                        dataKey="id"
                        width={width * 0.17}
                        flexGrow={1}
                      />
                    )}
                    {!isExpandOpen && (
                      <Column
                        disableSort={true}
                        cellRenderer={columnScanned}
                        className="audit-table__cell"
                        label={upperCase(t('audit.table.columns.scanned'))}
                        dataKey="scanned_items_count"
                        width={width * 0.16}
                        flexGrow={1}
                      />
                    )}
                    {!isExpandOpen && (
                      <Column
                        headerRenderer={h => sortHeader(h)}
                        cellRenderer={c =>
                          columnData(c, moment(c.rowData.start_date).format(date_format))
                        }
                        className="audit-table__cell"
                        label={upperCase(t('audit.table.columns.start_date'))}
                        dataKey="start_date"
                        width={width * 0.125}
                        flexGrow={1}
                      />
                    )}
                    {!isExpandOpen && (
                      <Column
                        headerRenderer={h => sortHeader(h)}
                        cellRenderer={columnDueDate}
                        className="audit-table__cell"
                        label={upperCase(t('audit.table.columns.due_date'))}
                        dataKey="due_date"
                        width={width * 0.125}
                        flexGrow={1}
                      />
                    )}
                    {!isExpandOpen && !permission && (
                      <Column
                        headerRenderer={h => sortHeader(h)}
                        cellRenderer={c => columnData(c, c.rowData.user_name)}
                        className="audit-table__cell"
                        label={upperCase(t('audit.table.columns.assigned_by'))}
                        dataKey="user_name"
                        width={width * 0.17}
                        flexGrow={1}
                      />
                    )}
                    {!isExpandOpen && permission && (
                      <Column
                        disableSort={true}
                        headerClassName={'actionSize'}
                        cellRenderer={columnAction}
                        style={{overflow: 'visible'}}
                        dataKey="id"
                        width={width * 0.02}
                        flexGrow={1}
                      />
                    )}
                  </Table>
                )}
              </InfiniteLoader>
            </div>
          </>
        )}
      </div>
    </>
  )
}
export default AuditTab
